/* ASYA BAYRAK — kampanya gösterimi davranışı · 07.10.2026
   - kod kutusuna dokununca kodu kopyalar (ürün / koleksiyon)
   - sepette "kodu uygula", elle kod yazma ve "kaldır"
   Olaylar belgeye bağlıdır: sepet penceresi her yenilendiğinde içerik değişse de çalışır.
   Dersler: currentScript KULLANMA · sayfada iki kez yüklenirse ikinci kez kurulmaz. */
(function () {
  if (window.__asyaKampanya) return;
  window.__asyaKampanya = true;

  var JSON_BASLIK = { Accept: 'application/json' };

  function kutu(el) { return el.closest('[data-asya-kmp]'); }

  function mesaj(kap, tur) {
    var m = kap && kap.querySelector('[data-asya-kod-mesaj]');
    if (!m) return;
    if (!tur) { m.hidden = true; m.textContent = ''; return; }
    m.textContent = m.getAttribute('data-' + tur) || '';
    m.hidden = false;
  }

  /* Temanın sepet formları (pencere + sepet sayfası) bu olayı dinleyip kendini yeniler. */
  function sepetiYenile() {
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
  }

  function kodUygula(kod, kap, dugme) {
    kod = (kod || '').trim();
    if (!kod) return;
    mesaj(kap, null);
    if (dugme) dugme.disabled = true;
    fetch('/discount/' + encodeURIComponent(kod) + '?redirect=/cart.js', { credentials: 'same-origin', headers: JSON_BASLIK })
      .then(function () { return fetch('/cart.js', { credentials: 'same-origin', headers: JSON_BASLIK }); })
      .then(function (r) { return r.json(); })
      .then(function (sepet) {
        var tamam = (sepet.discount_codes || []).some(function (d) {
          return d.code && d.code.toUpperCase() === kod.toUpperCase() && d.applicable;
        });
        if (tamam) { sepetiYenile(); } else { mesaj(kap, 'hata'); }
      })
      .catch(function () { mesaj(kap, 'hata'); })
      .then(function () { if (dugme) dugme.disabled = false; });
  }

  function kodKaldir(dugme) {
    if (dugme) dugme.disabled = true;
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function () { return fetch('/discount/%20?redirect=/cart.js', { credentials: 'same-origin', headers: JSON_BASLIK }); })
      .catch(function () {})
      .then(function () { sepetiYenile(); });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-asya-kod-kopyala],[data-asya-kod-uygula],[data-asya-kod-kaldir],[data-asya-kod-ac],[data-asya-kod-giris-uygula]') : null;
    if (!el) return;

    if (el.hasAttribute('data-asya-kod-kopyala')) {
      var bilgi = el.querySelector('.asya-kmp__kod-bilgi');
      var yaz = function () {
        if (!bilgi) return;
        bilgi.textContent = el.getAttribute('data-kopyalandi') || '✓';
        setTimeout(function () { bilgi.textContent = ''; }, 2200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(el.getAttribute('data-asya-kod-kopyala')).then(yaz, function () {});
      }
      return;
    }
    e.preventDefault();
    if (el.hasAttribute('data-asya-kod-uygula')) { kodUygula(el.getAttribute('data-asya-kod-uygula'), kutu(el), el); return; }
    if (el.hasAttribute('data-asya-kod-kaldir')) { kodKaldir(el); return; }
    if (el.hasAttribute('data-asya-kod-ac')) {
      var alan = kutu(el) && kutu(el).querySelector('[data-asya-kod-alan]');
      if (!alan) return;
      alan.hidden = !alan.hidden;
      el.setAttribute('aria-expanded', alan.hidden ? 'false' : 'true');
      if (!alan.hidden) { var g = alan.querySelector('[data-asya-kod-giris]'); if (g) g.focus(); }
      return;
    }
    if (el.hasAttribute('data-asya-kod-giris-uygula')) {
      var giris = kutu(el) && kutu(el).querySelector('[data-asya-kod-giris]');
      if (giris) kodUygula(giris.value, kutu(el), el);
    }
  });

  /* Urun sayfasi "KAMPANYA" dugmesi: fareyle uzerine gelince CSS acar; dokunmatikte dokununca ac/kapa. */
  function kartlariKapat(haric) {
    document.querySelectorAll('[data-asya-kmp-kutu].acik').forEach(function (k) {
      if (k === haric) return;
      k.classList.remove('acik');
      var b = k.querySelector('[data-asya-kmp-ac]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-asya-kmp-ac]') : null;
    if (btn) {
      var k = btn.closest('[data-asya-kmp-kutu]');
      kartlariKapat(k);
      var acik = k.classList.toggle('acik');
      btn.setAttribute('aria-expanded', acik ? 'true' : 'false');
      return;
    }
    if (e.target.closest && e.target.closest('.asya-urun-kmp-kart')) return;
    kartlariKapat(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-asya-kmp-kutu].acik').forEach(function (k) {
      k.classList.remove('acik');
      var b = k.querySelector('[data-asya-kmp-ac]');
      if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
    });
  });

  /* Ucretsiz kargo kutusu — para birimi dolar/TL degilse (EUR, GBP...) esik dolardan cevrilir.
     Esik %2 yukari alinir: sinirda "kazandiniz" deyip odemede ucret cikmasin. */
  function kargoKutulari() {
    var oran = window.Shopify && Shopify.currency ? parseFloat(Shopify.currency.rate) : NaN;
    document.querySelectorAll('[data-asya-kargo]').forEach(function (k) {
      if (!oran || isNaN(oran)) { k.hidden = true; return; }
      var esik = parseInt(k.getAttribute('data-esik-usd'), 10) * oran * 1.02;
      var kalan = (esik - parseInt(k.getAttribute('data-sepet'), 10)) / 100;
      if (kalan > 0) {
        var tutar;
        try {
          tutar = new Intl.NumberFormat(k.getAttribute('data-dil') || undefined, { style: 'currency', currency: k.getAttribute('data-para') }).format(Math.ceil(kalan * 100) / 100);
        } catch (err) { tutar = (Math.ceil(kalan * 100) / 100).toFixed(2) + ' ' + k.getAttribute('data-para'); }
        var d = document.createElement('div'); d.textContent = tutar;
        k.innerHTML = (k.getAttribute('data-kaldi') || '').replace('__TUTAR__', d.innerHTML);
        k.classList.remove('asya-kargo-mesaj--tamam');
      } else {
        k.textContent = '\u2713 ' + (k.getAttribute('data-tamam') || '');
        k.classList.add('asya-kargo-mesaj--tamam');
      }
      k.hidden = false;
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', kargoKutulari); } else { kargoKutulari(); }
  document.addEventListener('on:cart:after-merge', kargoKutulari);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-asya-kod-giris]')) return;
    e.preventDefault();
    var kap = kutu(e.target);
    kodUygula(e.target.value, kap, kap && kap.querySelector('[data-asya-kod-giris-uygula]'));
  });
})();
